import React from 'react'

import AddCategoryForm from '../../modules/Category/components/AddCategoryForm'
export default function AddSectionPage() {
  return <AddCategoryForm />
}
